const advisorForm = document.querySelectorAll('.m-advisor__form');

function initForm() {

    function setEventListeners() {
        const nextButtons = document.querySelectorAll('.advisorNextButton');
        const previousButtons = document.querySelectorAll('.advisorPreviousButton');
        const advisorForm = document.querySelector('.m-advisor__form');

        [].map.call(nextButtons, button => button.addEventListener('click', nextTab.bind(button, advisorForm)));
        [].map.call(previousButtons, button => button.addEventListener('click', previousTab.bind(button, advisorForm)));
    }

    function nextTab(advisorForm, button)
    {
        const tabs = document.querySelectorAll('.m-advisor__wrap');
        const steps = document.querySelectorAll('.m-advisor__step');

        advisorForm.dataset.currentStep = parseInt(advisorForm.dataset.currentStep) + 1;

        if(tabs.length == advisorForm.dataset.currentStep) {
            setResultsContent();
        }

        setTabs(tabs, advisorForm.dataset.currentStep);
        setSteps(steps, advisorForm.dataset.currentStep);
    }

    function previousTab(advisorForm, button)
    {
        const tabs = document.querySelectorAll('.m-advisor__wrap');
        const steps = document.querySelectorAll('.m-advisor__step');

        advisorForm.dataset.currentStep = parseInt(advisorForm.dataset.currentStep) - 1;

        setTabs(tabs, advisorForm.dataset.currentStep);
        setSteps(steps, advisorForm.dataset.currentStep);
    }

    function setResultsContent()
    {
        const answers = document.querySelectorAll('.m-advisor__answers');
        var answerString = '';

        answers.forEach(function(answerContainer) {
            const buttons = answerContainer.querySelectorAll('input');

            buttons.forEach(function(button, i) {
                if(button.checked) {
                    answerString = answerString + (i + 1);
                };
            });
        });

        const answerContainer = document.getElementById('advisor-form-answers');
        answerContainer.value = answerString;

        const results = document.querySelectorAll('.m-advisor__result');
        
        results.forEach(function(result) {
            if(result.classList.contains(answerString)) {
                result.classList.add('visible');
            }
        });
    }

    function setTabs(tabs, currentStep)
    {
        tabs.forEach(function(tab){
            if(tab.classList.contains('current')) {
                tab.classList.remove('current');
            }

            if(tab.dataset.step == currentStep) {
                tab.classList.add('current');
            }
        }); 
    }

    function setSteps(steps, currentStep)
    {
        steps.forEach(function(step){
            if(step.classList.contains('current')) {
                step.classList.remove('current');
            }

            if(step.classList.contains('done')) {
                step.classList.remove('done');
            }

            if(step.dataset.step < currentStep) {
                step.classList.add('done');
            }

            if(step.dataset.step == currentStep) {
                step.classList.add('current');
            }
        }); 
    }

    setEventListeners();
    if (Number(advisorForm[0].dataset.currentStep) > 1) {
        setResultsContent();
        setTabs(document.querySelectorAll('.m-advisor__wrap'), advisorForm[0].dataset.currentStep);
        setSteps(document.querySelectorAll('.m-advisor__step'), advisorForm[0].dataset.currentStep);
    }
}

if (advisorForm.length) initForm();
